<script>
	/*
		TCareComment.svelte
	*/

	import { onMount } from 'svelte';

	export let label;
	export let cssClass;			// a string id
	
    onMount(() => {
		// console.log('');
		// console.log('TCareComment onMount');
		// console.log('label: ' + label);
		// console.log('cssClass: ' + cssClass);
    })


</script>

<style>
</style>

<div class="tcui-comment">
	<div class={cssClass}>{label}</div>
	<!-- <input class="input" value={source[prop]} on:keyup={_onKeyUp}/> -->
</div>
